import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const rows = [
  {
    product: 'Entrevista mensual',
    detail: 'Bloque extendido para profundizar en la agenda de Nexus Cultural y «Sanando con los Ángeles».',
    investment: 'Incluido',
  },
  {
    product: 'Presencia en redes',
    detail: 'Reels en colaboración entre la cuenta @PuntodeFe y Nexus Cultural.',
    investment: 'Incluido',
  },
  {
    product: 'Banners web',
    detail: 'Presencia fija en el portal de TNO Network con enlace directo a consultas o eventos.',
    investment: 'Incluido',
  },
];

const InvestmentSummary = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Inversión
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Modelo ganar-ganar
        </Box>
        <Typography variant="body1" color="textSecondary" align="center" sx={{ maxWidth: 560, mx: 'auto' }}>
          Plan accesible que fortalece la unión entre Margarita Toledo y Nexus Cultural con visibilidad
          integral en programa, redes y web.
        </Typography>
      </Box>
      <TableContainer
        component={Paper}
        elevation={2}
        sx={{ maxWidth: 720, mx: 'auto', borderRadius: 2 }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Concepto</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Alcance</TableCell>
              <TableCell align="right" sx={{ color: 'white', fontWeight: 700 }}>
                Paquete
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i} hover>
                <TableCell>{row.product}</TableCell>
                <TableCell>{row.detail}</TableCell>
                <TableCell align="right">{row.investment}</TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell
                colSpan={2}
                sx={{ fontWeight: 700, color: theme.palette.primary.contrastText }}
              >
                INVERSIÓN MENSUAL TOTAL
              </TableCell>
              <TableCell
                align="right"
                sx={{ fontWeight: 700, color: theme.palette.primary.contrastText }}
              >
                $300
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ maxWidth: 720, mx: 'auto', mt: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary">
          Incluye integración en Punto de Fe, digest, rotativa y entregables acordados en la estructura de
          alianza. © TNO Network 2026 | The Content Evolution.
        </Typography>
      </Box>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default InvestmentSummary;
